import PropTypes from "prop-types";
import { ModalHeaderWithActions } from "@evertrue/et-components";
import EmailTemplatesLibrary from "./email-templates-library";
import EmailTemplatePreview from "./email-template-preview";

const EmailTemplatesModal = ({ closeModal, setShowEditView, showEditView, selectedTemplate, setSelectedTemplate, emailBodyRef, setSubject }) => {
    
  const handleInsertTemplate = () => {
    const editor = emailBodyRef.current.getEditor();
    let idx = 0;
    if (editor.selection.lastRange){ // If there is a cursor position, insert the template at the cursor
      idx = editor.selection.lastRange.index;
    } else {
      idx = editor.getLength();
    }
    editor.clipboard.dangerouslyPasteHTML(idx, selectedTemplate.templateBody);
    setSubject(selectedTemplate.templateSubject);
    closeModal();
  }

  return (
    <>
      <ModalHeaderWithActions
        submitLabel="Insert Template"
        title="Email Template Library"
        closeModal={closeModal}
        onSubmit={handleInsertTemplate}
        disableSubmit={!selectedTemplate.templateBody}
      ></ModalHeaderWithActions>
      <div style={{ display: "flex" }}>
        <EmailTemplatesLibrary
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          setShowEditView={setShowEditView}
          showEditView={showEditView}
        />
        <EmailTemplatePreview template={selectedTemplate} />
      </div>
    </>
  );
};

EmailTemplatesModal.propTypes = {
  closeModal: PropTypes.func,
  setShowEditView: PropTypes.func,
  selectedTemplate: PropTypes.object,
  setSelectedTemplate: PropTypes.func,
  showEditView: PropTypes.bool,
  emailBodyRef: PropTypes.object,
  setSubject: PropTypes.func,
};

export default EmailTemplatesModal;
